import { api } from '../services/api.js';

/**
 * 390 (#1310) — saves a finished rental's receipt PDF to the device. The file is fetched with the session's own
 * credential (`getBlobUrl`), then saved through a temporary link, so it lands in Files or Downloads like any download.
 *
 * The file name repeats the platform's receipt number rule (`R` + the last 8 characters of the rental's id, upper case;
 * `backend/src/modules/receipts/receipt.ts`), because a saved object URL cannot carry the server's file name.
 */
export function receiptFileName(rentalId: string): string {
  return `CARii-receipt-R${rentalId.slice(-8).toUpperCase()}.pdf`;
}

export async function downloadReceipt(bookingId: string, rentalId: string): Promise<void> {
  const { url } = await api.getBlobUrl(`/bookings/${bookingId}/receipt`);
  const link = document.createElement('a');
  link.href = url;
  link.download = receiptFileName(rentalId);
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Give the browser a moment to start the download before the address is released.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
